import {UserContext} from "@hosttools/frontend";

export type {UserContextType} from "@hosttools/frontend/react/contexts/UserContext";

const UserConsumer = UserContext.Consumer;
export {UserContext, UserConsumer};
